import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["name", "value", "checked"]
const _hoisted_2 = ["data-count"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(["CategoryFilterItemCheck", {'is-disabled': _ctx.data.count === 0, 'is-hidden': _ctx.hidden && !_ctx.data.checked }])
  }, [
    _createElementVNode("input", {
      type: "checkbox",
      name: _ctx.data.name,
      value: _ctx.data.value,
      checked: _ctx.data.checked,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleChange({ name: _ctx.data.name, value: _ctx.data.value }))),
      class: "CheckboxBase"
    }, null, 40, _hoisted_1),
    _createElementVNode("span", {
      "data-count": _ctx.data.count !== null ? '(' + _ctx.data.count + ')' : ''
    }, _toDisplayString(_ctx.data.label), 9, _hoisted_2)
  ], 2))
}